import { render, staticRenderFns } from "./GHpolicy_a.vue?vue&type=template&id=53facab6&"
import script from "./GHpolicy_a.vue?vue&type=script&lang=js&"
export * from "./GHpolicy_a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports